// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"be153942f0cc3bf2","931":"52fb9afc8d41e4f3"}[chunkId] + ".css";
};